import React, { useState } from 'react';
import { Paper, Typography, Grid, Button, TextField, Box, CssBaseline, Avatar, Alert, Snackbar, CircularProgress } from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import tecsirImage from '../assets/Login/tecsir2.png';
import ticoIcon from '../assets/Login/tico.ico';
import Copyright from '../components/copyRight';

const defaultTheme = createTheme();

export default function SignInSide({ setIsAuthenticated }) {
    const [body, setBody] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState(''); // State for success message
    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false); // State for controlling success message
    const navigate = useNavigate();

    const inputChange = ({ target }) => {
        const { name, value } = target;
        setBody({
            ...body,
            [name]: value
        });
    };

    const onSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSuccessMessage('');
        setLoading(true);

        try {
            const response = await axios.post(
                'https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/login',
                body,
                { headers: { 'Content-Type': 'application/json' } }
            );

            const raw = response.data;
            let data;

            try {
                data = typeof raw === 'string' ? JSON.parse(raw) : raw;
            } catch {
                data = null;
            }

            if (data?.success === true) {
                const { username, fullname, depa, tipoUsuario, permissions } = data.user || {};

                if (username) localStorage.setItem('username', username);
                if (fullname) localStorage.setItem('userFullname', fullname);
                if (depa) localStorage.setItem('userDepa', depa);
                if (tipoUsuario) localStorage.setItem('tipoUsuario', tipoUsuario);
                if (data.token) localStorage.setItem('userToken', data.token);

                localStorage.setItem(
                    'emsPermissions',
                    JSON.stringify(
                        permissions || {
                            accessLevel: 'USER',
                            machines: []
                        }
                    )
                );

                setSuccessMessage('Login successful!');
                setOpenSnackbar(true);
                setIsAuthenticated(true);

                setTimeout(() => {
                    navigate('/dashboard');
                }, 1500);
            } else {
                setError('Invalid username or password');
            }
        } catch (err) {
            console.error("[ERROR] Error en la solicitud:", err);

            if (err.response && err.response.status === 401) {
                setError('Invalid username or password');
            } else {
                setError('An error occurred. Please try again later.');
            }
        } finally {
            setLoading(false);
        }
    };
    
    
    
    const handleSnackbarClose = () => {
        setOpenSnackbar(false); // Close Snackbar
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Grid container component="main" sx={{ height: '100vh' }}>
                <CssBaseline />
                <Grid
                    item
                    xs={false}
                    sm={4}
                    md={7}
                    sx={{
                        backgroundImage: `url(${tecsirImage})`,
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'left',
                    }}
                />
                <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            marginTop: 32,
                        }}
                    >
                        <Avatar sx={{ m: 1, width: 56, height: 56 }} src={ticoIcon} />
                        <Typography component="h1" variant="h5">
                            EMS REMCON
                        </Typography>
                        <Box component="form" noValidate sx={{ mt: 1 }} onSubmit={onSubmit}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="user"
                                label="Usuario"
                                name="username"
                                autoComplete="User"
                                autoFocus
                                value={body.username}
                                onChange={inputChange}
                                disabled={loading}
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Contraseña"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                value={body.password}
                                onChange={inputChange}
                                disabled={loading}
                            />
                            {/* Display error message if any */}
                            {error && <Alert severity="error">{error}</Alert>}
                            
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, height: 40 }}
                                disabled={loading}                   // evita doble envío
                            >
                            {loading ? <CircularProgress size={22} color="inherit" /> : 'Login'}
    
                            </Button>
                            <Copyright sx={{ mt: 5 }} />
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            {/* Snackbar for Success Message */}
            <Snackbar
                open={openSnackbar}
                autoHideDuration={1500} // Show the message for 1.5 seconds
                onClose={handleSnackbarClose}
                message={successMessage} // Success message text
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} // Display the Snackbar at the bottom center
            />
        </ThemeProvider>
    );
}

